'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCalendarLines, iconCalendarLinesTag } from '@ni/nimble-components/dist/esm/icons/calendar-lines';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCalendarLines };
export { iconCalendarLinesTag };
export const NimbleIconCalendarLines = wrap(IconCalendarLines);